import { Employee } from '@/containers/HoursByDay/types';

export function utilizeEmployeeListOptions(data: Employee[] | undefined) {
  if (!data) return [];
  return data.map(({ id, name }) => ({ value: id, label: name }));
}
